import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

interface TrackingItem {
  slug: string;
  title: string;
  excerpt: string;
  badge: string;
  imageUrl: string;
}

const trackingArticles: TrackingItem[] = [
  {
    slug: 'esports-player-match-fixing',
    title: '电竞顶流选手涉嫌假赛被联盟禁赛，俱乐部火线解约',
    excerpt: '联盟官方发布禁赛公告，多家俱乐部连夜排查选手聊天记录',
    badge: '爆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20empty%20gaming%20chairs%20and%20dimmed%20stage%20lights%2C%20a%20single%20monitor%20displaying%20a%20red%20warning%20message%2C%20dramatic%20atmosphere%20with%20purple%20and%20blue%20stage%20lighting%2C%20empty%20stadium%20seats%20in%20background%2C%20competitive%20gaming%20controversy%20mood%2C%20cinematic%20wide%20angle%2C%20atmospheric%20haze%20and%20spotlight%20beams%2C%20high%20contrast%20dramatic%20photography&width=600&height=800&seq=tracking-card-01&orientation=portrait',
  },
  {
    slug: 'popular-actor-cheating-scandal',
    title: '某视帝被拍到深夜与神秘女子同回酒店，妻子微博沉默',
    excerpt: '狗仔蹲守72小时拍到实锤画面，当事人团队至今未作任何回应',
    badge: '沸',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20dim%20ambient%20lighting%2C%20paparazzi%20perspective%20through%20car%20window%20with%20rain%20drops%2C%20mysterious%20atmosphere%20with%20blurred%20figures%20in%20distance%2C%20cinematic%20voyeur%20style%2C%20dark%20blue%20and%20yellow%20hotel%20lighting%20contrast%2C%20moody%20nighttime%20urban%20scene%2C%20editorial%20tabloid%20photography%20aesthetic%2C%20dramatic%20shadows%20and%20highlights&width=600&height=800&seq=tracking-card-02&orientation=portrait',
  },
  {
    slug: 'celebrity-tax-evasion-2026',
    title: '又一位明星因税务问题被约谈，工作室连夜发文回应',
    excerpt: '税务局官网更新信息引发网友热议，工作室凌晨三点紧急发布声明',
    badge: '热',
    imageUrl: 'https://readdy.ai/api/search-image?query=Official%20government%20building%20exterior%20at%20night%20with%20dim%20lights%20in%20windows%2C%20rainy%20atmosphere%2C%20a%20lone%20figure%20walking%20away%20in%20the%20distance%2C%20moody%20cinematic%20photography%2C%20dark%20blue%20and%20gray%20color%20palette%2C%20raining%20street%20scene%20with%20reflections%20on%20wet%20pavement%2C%20mysterious%20and%20serious%20atmosphere%2C%20editorial%20news%20photography%20style%2C%20cold%20tones%20with%20subtle%20warm%20window%20light%20contrast&width=600&height=800&seq=tracking-card-03&orientation=portrait',
  },
  {
    slug: 'movie-star-contract-dispute',
    title: '影帝与经纪公司对簿公堂，天价违约金案今日开庭',
    excerpt: '双方各执一词，法院外聚集大量粉丝和媒体记者',
    badge: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Courthouse%20exterior%20with%20media%20reporters%20and%20cameras%20gathered%20outside%20on%20the%20steps%2C%20dramatic%20overcast%20sky%2C%20tension%20in%20the%20air%2C%20legal%20dispute%20atmosphere%2C%20photojournalism%20style%2C%20gray%20and%20muted%20tones%20with%20flashes%20of%20camera%20lights%2C%20crowd%20scene%20with%20professional%20news%20gathering%20equipment%2C%20serious%20and%20urgent%20mood&width=600&height=800&seq=tracking-card-04&orientation=portrait',
  },
  {
    slug: 'rapper-diss-track-controversy',
    title: '说唱歌手发歌DISS半个娱乐圈，多位艺人点赞又秒删',
    excerpt: '新歌歌词含沙射影指向多位顶流，评论区秒变战场',
    badge: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Recording%20studio%20with%20professional%20microphone%20and%20sound%20equipment%2C%20sheet%20music%20with%20aggressive%20lyrics%20visible%2C%20dark%20moody%20atmosphere%20with%20red%20and%20blue%20studio%20lights%2C%20hip%20hop%20music%20production%20scene%2C%20cinematic%20close-up%20of%20microphone%20with%20dramatic%20shadows%2C%20urban%20music%20culture%20aesthetic%2C%20high%20contrast%20moody%20photography%2C%20professional%20music%20studio%20environment&width=600&height=800&seq=tracking-card-05&orientation=portrait',
  },
  {
    slug: 'actress-secret-marriage-revealed',
    title: '当红女星被拍到与圈外男友领证，工作室默认已结婚',
    excerpt: '网友偶遇民政局门口偶遇，照片细节与时间线完全吻合',
    badge: '',
    imageUrl: 'https://readdy.ai/api/search-image?query=Civil%20affairs%20bureau%20building%20entrance%20on%20a%20sunny%20day%20with%20blooming%20cherry%20blossoms%20nearby%2C%20a%20romantic%20yet%20secretive%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20shallow%20depth%20of%20field%20focusing%20on%20the%20building%20sign%2C%20warm%20and%20dreamy%20color%20palette%20with%20pink%20and%20gold%20tones%2C%20editorial%20photography%20style%2C%20hopeful%20and%20intimate%20mood%2C%20soft%20bokeh%20background&width=600&height=800&seq=tracking-card-06&orientation=portrait',
  },
];

export default function LatestTracking() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };

  const scroll = (direction: 'left' | 'right') => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = 320;
    el.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
    setTimeout(checkScroll, 350);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950">
              最新黑料追踪
            </h2>
            <p className="mt-2 text-foreground-500 text-sm md:text-base">持续追踪，不错过任何后续进展</p>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className={`w-10 h-10 flex items-center justify-center rounded-lg border transition-all cursor-pointer whitespace-nowrap ${
                canScrollLeft
                  ? 'border-foreground-300 text-foreground-700 hover:bg-foreground-100'
                  : 'border-foreground-200 text-foreground-300 cursor-not-allowed'
              }`}
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className={`w-10 h-10 flex items-center justify-center rounded-lg transition-all cursor-pointer whitespace-nowrap ${
                canScrollRight
                  ? 'bg-foreground-900 text-white hover:bg-foreground-800'
                  : 'bg-foreground-300 text-white cursor-not-allowed'
              }`}
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          onScroll={checkScroll}
          className="flex gap-4 md:gap-5 overflow-x-auto pb-2"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {trackingArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="flex-shrink-0 w-[280px] md:w-[300px] group cursor-pointer"
            >
              <div className="relative rounded-xl overflow-hidden h-[360px]">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                {article.badge && (
                  <span className="absolute top-3 right-3 px-2.5 py-0.5 bg-accent-500 text-white text-xs font-bold rounded-full whitespace-nowrap">
                    {article.badge}
                  </span>
                )}
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-heading text-lg font-bold text-white leading-snug mb-1 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-white/60 text-xs line-clamp-1">{article.excerpt}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}